import {hel_isLangJa} from '../../logics/platform';
import {hel_toast_notify_message} from '../../logics/shared';

import {CAchievementApiNotification} from './CAchievementApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
import type {ReturnSuccess} from '../../../../HeliportJS/dist/models/return';

export class CAchievement {
  m_AchievementApiNotification: CAchievementApiNotification | null = null;

  // コンストラクタ
  constructor() {
    this.m_AchievementApiNotification = new CAchievementApiNotification();
  }

  /** トーストによる通知 */
  addReceivedToastEventListener(fn: (params: JsonObject) => void) {
    this.m_AchievementApiNotification?.addPersonalEvent(fn);
  }

  /** トーストによる通知 */
  async receive(params: Record<string, any>) {
    const returnValue = await globalThis.heliport.v3.api.achievement.fetchAchievementInformation({
      label: params.ReferenceID
    });
    if (returnValue.status !== 'ok') {
      throw new Error(
        `Failed to fetch achievement information:\n${JSON.stringify(returnValue, null, 2)}`
      );
    }
    const {
      data: {achievement}
    } = returnValue as ReturnSuccess<{
      achievement: {
        id: number;
        title: string;
        description: string;
        title_en: string;
        description_en: string;
        thumbnail: {
          url: string | null;
        };
        ingame_thumbnail: {
          url: string | null;
        };
        accomplished_at: string;
        created_at: string;
        updated_at: string;
      };
    }>;
    const isLangJa = hel_isLangJa();
    let achievementName = isLangJa ? achievement.title : achievement.title_en;
    if (achievementName.length > 15) {
      achievementName = achievementName.substring(0, 15) + '...';
    }
    // TODO: 英語の通知
    const message = isLangJa
      ? `アチーブメント「${achievementName}」を獲得しました！`
      : `アチーブメント「${achievementName}」を獲得しました！`;

    hel_toast_notify_message(message);
  }
}
